import { useEffect, useMemo, useState } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';

import { FazendaService } from  '../services/api/cadastros/FazendaService';
import { useDebounce } from '../hooks';
import { useField } from '@unform/core';


type TAutoCompleteOption = {
  idfazenda: string;
  label: string;
}

interface IAutoCompleteFazendaProps {
  isExternalLoading?: boolean;
  uuidfazenda?: (novoTextoselect: string | undefined) => void;
  nome?: (novoTextoselect: string | undefined) => void;
}
export const AutoCompleteFazendaAlmoco: React.FC<IAutoCompleteFazendaProps> = ({ isExternalLoading = false, uuidfazenda, nome }) => {
  const { fieldName, registerField, defaultValue, error, clearError } = useField('idfazalmoco');
  const { debounce } = useDebounce();

  const [selectedId, setSelectedId] = useState<string | undefined>(defaultValue);

  const [opcoes, setOpcoes] = useState<TAutoCompleteOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [busca, setBusca] = useState('');

  useEffect(() => {
    registerField({
      name: fieldName,
      getValue: () => selectedId,
      setValue: (_, newSelectedId) => setSelectedId(newSelectedId),
    });
  }, [registerField, fieldName, selectedId]);

  useEffect(() => {
    setIsLoading(true);

    debounce(() => {  
      FazendaService.getAlllist(selectedId, busca)
        .then((result) => {
          setIsLoading(false);

          if (result instanceof Error) {
            // alert(result.message);
          } else {
            setOpcoes(result.data.map(fazenda => ({ idfazenda: fazenda.idfazenda, label: fazenda.descricao })));
          }
        });
    });  
  }, [busca, selectedId]);

  const autoCompleteSelectedOption = useMemo(() => {
    if (!selectedId) return null;

    const selectedOption = opcoes.find(opcao => opcao.idfazenda === selectedId);
    if (!selectedOption) return null;

    return selectedOption;
  }, [selectedId, opcoes]);


  return (
    <Autocomplete
      openText='Abrir'
      closeText='Fechar'
      noOptionsText='Sem opções'
      loadingText='Carregando...'

      disablePortal

      options={opcoes}
      loading={isLoading}
      disabled={isExternalLoading}
      value={autoCompleteSelectedOption}
      onInputChange={(_, newValue) => setBusca(newValue)}
      onChange={(_, newValue) => { setSelectedId(newValue?.idfazenda); uuidfazenda?.(newValue?.idfazenda); nome?.(newValue?.label); setBusca(''); clearError(); }}
      popupIcon={(isLoading) ? <CircularProgress size={28} /> : undefined}
      renderInput={(params) => (
        <TextField
          {...params}
          size='small'
          label="Fazenda Almoço" 
          error={!!error}
          helperText={error}
        />
      )}
    />
  );
};